import React, { useEffect } from 'react';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useSelector, useDispatch } from 'react-redux';
import { TRootState } from 'redux/reducers/rootReducer';
import useStatusDynamic from 'hooks/useStatusDynamic';
import EStatusAPIKeys from 'types/backend_models/lookup_status/EStatusAPIKeys';
import useCombinedRequestStatus from 'hooks/useCombinedRequestStatus';
import { useSearchTableQuery } from 'hooks/urlHooks';
import { combineTableQueryData } from 'functions/tables/TableFunctions';
import { ResetScroll } from 'functions/General';
import RequestStatus from 'types/general/requests/RequestStatus';
import IStatusModel from 'types/backend_models/lookup_status/IStatusModel';
import { LargeLoadingIndicator } from 'components/content/shared/other/LoadingIndicator';
import { LargeErrorMessage } from 'components/content/shared/other/ErrorMessage';
import { initialQueryData, fetchInvoices } from 'redux/actions/dataActions/invoices/InvoicesActions';
import { resetInvoicesFetchStatus } from 'redux/reducers/data_action_reducers/invoices/InvoicesReducer';
import { InvoicesTable } from './InvoicesTable';

var completedSetup = false;

export function InvoicesOverViewPage()
{
	const dispatch = useDispatch();
	const thunkDispatch = useThunkDispatch();
	const invoicesState = useSelector((rootState: TRootState) => rootState.data.invoices.overview);
	const invoicesStatusState = useStatusDynamic(EStatusAPIKeys.invoiceStatuses);
	const combinedRequestStatus = useCombinedRequestStatus(invoicesState, invoicesStatusState);
	const { updateSearchByTableQuery, getTableQueryFromSearch } = useSearchTableQuery();

	// console.log('combinedRequestStatus', combinedRequestStatus);
	// console.log('invoicesState', invoicesState);

	// Initialization call
	useEffect(() =>
	{
		ResetScroll();
		const searchQuery = getTableQueryFromSearch();
		const queryData = combineTableQueryData(searchQuery, initialQueryData);


		// Update url search
		updateSearchByTableQuery(queryData);
		// Send fetch request
		thunkDispatch(fetchInvoices(queryData));

		return function cleanup()
		{
			dispatch(resetInvoicesFetchStatus());
			completedSetup = false;
		}

		// eslint-disable-next-line
	}, []);

	if (combinedRequestStatus.requestStatus === RequestStatus.succes) {
		completedSetup = true;
	}



	return (
		<div className="invoices-overview-page">
			{
				completedSetup &&
				<>
					<h1 className="page-title mgb-5">Your Invoices</h1>
					<h3 className="page-subtitle mgb-25">An overview of the invoices issued to your organisation and the payment status.</h3>
					<InvoicesTable
						invoicesState={invoicesState}
						invoiceStatusses={invoicesStatusState.data as IStatusModel[]}
					/>
				</>
			}
			{
				!completedSetup &&
				<LargeLoadingIndicator />
			}
			{
				combinedRequestStatus.requestStatus === RequestStatus.error &&
				<LargeErrorMessage />
			}
		</div>
	);
};